import { NotFoundComponent } from '@shared/components';
import {
  OnboardingRoutesPublic,
  CheckoutRoutesPublic,
  CrossSellerRoutesPublic,
} from '@shared/modules';
import { createBrowserRouter } from 'react-router-dom';

export const ProtectedRoutes = createBrowserRouter([
  ...CheckoutRoutesPublic(),
  ...OnboardingRoutesPublic(),
  ...CrossSellerRoutesPublic(),
  {
    path: '*',
    element: <NotFoundComponent />,
  },
]);
